import { z } from 'zod';

export const PASSWORD_REQUIREMENTS_MESSAGE =
  'Mínimo 10 caracteres, 1 mayúscula y 1 número';

export const passwordSchema = z
  .string()
  .min(10, { message: PASSWORD_REQUIREMENTS_MESSAGE })
  .regex(/[A-Z]/, { message: PASSWORD_REQUIREMENTS_MESSAGE })
  .regex(/[0-9]/, { message: PASSWORD_REQUIREMENTS_MESSAGE });

export const registerSchema = z
  .object({
    email: z.string().email({ message: 'Correo electrónico inválido' }),
    password: passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmPassword'],
  });

export type RegisterInput = z.infer<typeof registerSchema>;

// 010 · Fijar nueva contraseña en /reset-password. Reusa passwordSchema (misma política que el alta).
export const newPasswordSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmPassword'],
  });

export type NewPasswordInput = z.infer<typeof newPasswordSchema>;

export type PasswordStrengthLevel = 'weak' | 'medium' | 'strong';

export interface PasswordStrength {
  score: 0 | 1 | 2 | 3 | 4 | 5;
  level: PasswordStrengthLevel;
}

export function scorePassword(password: string): PasswordStrength {
  let score = 0;
  if (password.length >= 10) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;

  const safeScore = Math.max(0, Math.min(5, score)) as PasswordStrength['score'];
  const level: PasswordStrengthLevel =
    safeScore <= 2 ? 'weak' : safeScore <= 3 ? 'medium' : 'strong';

  return { score: safeScore, level };
}
